import type { ReactNode } from 'react';
import { cx } from '../internal/tone';

export interface StackProps {
  children: ReactNode;
  /** `sm` são 12 px — a separação mínima entre dois alvos de toque. */
  gap?: 'sm' | 'md' | 'lg';
  direction?: 'row' | 'column';
  className?: string;
}

/** Empilhamento simples. Existe para ninguém escrever margens à mão. */
export function Stack({
  children,
  gap = 'md',
  direction = 'column',
  className,
}: StackProps) {
  return (
    <div
      className={cx('flos-stack', `flos-stack--${direction}`, `flos-stack--gap-${gap}`, className)}
    >
      {children}
    </div>
  );
}
